const config = {
  API_URL: process.env.REACT_APP_API_URL,
  AMPLITUDE_KEY: process.env.REACT_APP_AMPLITUDE_KEY,
  SENTRY_ENV: process.env.REACT_APP_SENTRY_ENV,
  TEMPLATE_URL: process.env.REACT_APP_TEMPLATE_URL,
  COUNTRY_CODE: process.env.REACT_APP_TENANT_CONFIG,
  DOWNTIME_CHECK_URL: process.env.REACT_APP_DOWNTIME_CHECK_URL,
  MOENGAGE_APP_ID: process.env.REACT_APP_MOENGAGE_WORKSPACE_ID,
  API_KEY: process.env.REACT_APP_API_KEY,
  SD_AGENT_URL: process.env.REACT_APP_SD_AGENT_URL,
  OPENAI_URL: process.env.REACT_APP_OPENAI_URL,
};

export default config;
